module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjUiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyNSAxOSI+PGRlZnM+PHBhdGggaWQ9ImNpcThhIiBkPSJNNDUuMzEgMTU2LjYybC00LjY5IDMuODUtNy4wMy02LjkzLTUuNDcgNi45M3Y2LjkzaDIwLjMyek01MCAxNjguOTRIMjYuNTZWMTUySDI1djE4LjQ4aDI1eiIvPjwvZGVmcz48Zz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjUgLTE1MikiPjx1c2UgZmlsbD0iI2ZmZiIgeGxpbms6aHJlZj0iI2NpcThhIi8+PC9nPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./components/atoms/Icon/icons/dashboard--active.svg
// module id = 1723
// module chunks = 0